/**
 * Platform status reads.
 *
 * Part of the Console's API client: import from `engine/api.js`, which re-exports this module.
 *
 * This module held six further calls until they were removed as dead: `listVenues`,
 * `checkHealth`, `getSchedulerMetrics`, `getDetectionMetrics`, `getActiveAlerts` and
 * `ingestInfraSamples`. Five of them targeted `/venues` and `/metrics/*`, which `main.py`
 * mounts behind `require_role("operator", "admin")`, so each would have 403'd for the only
 * principal the Console has (`role=customer`); `ingestInfraSamples` was the one write
 * among them, a `POST /metrics/infra/ingest` host-agent batch upload. `checkHealth` is
 * the exception and is called out so nobody concludes a customer-side health read is
 * impossible: root `/health` is always registered and public (`main.py`, "Root /health
 * is ALWAYS registered"), so that one went purely for having no caller. They were
 * residue of the operator/research dual view removed on 2026-09-22 (ADR 0004 / E06);
 * that content lives in Argus. Do not add a read here that a customer token cannot make.
 */

import { BASE, parseJsonOrThrow } from "./apiTransport";

/**
 * GET /platform-status (OMEGA-1024 FR11) — is the platform accepting new workload?
 *
 * Returns `{ active, message, since }`; `message` and `since` are null while
 * `active` is false. Public and unauthenticated by design: a visitor who is not
 * signed in has to be able to see the notice, which is the whole point of US2.
 *
 * Sent WITHOUT the Authorization header, which is now the only shape this module
 * has: it is the sole remaining read here. The route takes no principal, the poll
 * runs on the login screen where there is no credential to send, and a stale token
 * on a public route buys nothing. The backend sends `Cache-Control: no-store`, so a cached
 * `active: false` cannot outlive the toggle.
 *
 * The Console reads THIS route, never `GET /argus/maintenance`: that one is
 * operator-only and carries the actor, which a customer has no business seeing.
 */
export async function getPlatformStatus() {
  const res = await fetch(`${BASE}/platform-status`);
  return parseJsonOrThrow(res);
}
